import React from "react";
import { Col, Row, Image, Button, Table } from "react-bootstrap";
import moment from "moment";
import { ChatScreenIssuesTrack } from "../../../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ChatScreenTrack";

import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import isEmpty from "../../../../../store/validation/is-Empty";
const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const AdminViewIssuesRight = (
  props
  // {
  //   tableBody,
  //   sendDataProps,
  //   displayChatScreen,
  //   displayInput,
  //   displayChatScreenFunc,
  //   onComment,
  //   onChange,
  //   commentValue,
  //   onClickChatButton,
  //   comment,
  // }
) => {
  return (
    <React.Fragment>
      <div className="open_issues_view_tickets_right">
        <div className="px-4 py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center f12-500">
              {props.showChat && (
                <i
                  className="fa fa-long-arrow-left mr-3 cursor-pointer"
                  aria-hidden="true"
                  onClick={props.onClickShowLog}
                ></i>
              )}
              Resolution Log
            </div>
            {props.showLog ? (
              <span
                onClick={() => props.handleChatSHow()}
                className="f12-500 text-blue cursor"
              >
                View all
              </span>
            ) : (
              <>
                <div className="d-flex align-items-center">
                  <div className="mr-2">
                    <SimpleReactLightbox>
                      <SRLWrapper options={options}>
                        <Image
                          fluid
                          alt="Restaurant Photo"
                          title="Restaurant Photo"
                          className="rounded-circle"
                          style={{ maxWidth: "32px" }}
                          src={
                            props.logData &&
                            props.logData.restaurant_id &&
                            props.logData.restaurant_id.logo_url
                          }
                        />
                      </SRLWrapper>
                    </SimpleReactLightbox>
                  </div>

                  <div className="mr-2 f12-500">
                    {props.logData &&
                      props.logData.restaurant_id &&
                      props.logData.restaurant_id.restaurant_name}
                  </div>
                </div>{" "}
              </>
            )}
          </div>
        </div>

        {props.showLog && (
          <Table className="w-100 enResolutionLogTBL">
            <thead>
              <tr>
                <th style={{ width: "20%" }} className="pl-4">
                  <div className="f10-500">Date</div>
                </th>
                <th style={{ width: "60%" }}>
                  <div className="f10-500">Comments</div>
                </th>
                <th style={{ width: "20%" }} className="pr-4 text-center">
                  <div className="f10-500">Comments By</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* {logData.ticketLogs.map((log,index)=>())} */}

              {props.logData &&
                props.logData.resolution_logs &&
                props.logData.resolution_logs.map((log, index) => (
                  <tr key={index}>
                    <td style={{ width: "20%" }} className="pl-4">
                      <div className="f10-400">
                        {" "}
                        {moment(log.date).format("Do MMMM, YYYY")}
                      </div>
                      <div className="f10-500">
                        {moment(log.date).format("hh:mm A")}
                      </div>
                    </td>
                    <td style={{ width: "60%" }}>
                      <div className="f10-400">{log.comment}</div>
                    </td>
                    <td style={{ width: "20%" }} className="pr-4 text-center">
                      <div className="f10-400">{log.initiator}</div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}

        {props.showChat && (
          <React.Fragment>
            <div className="col-12 open_issues_view_tickets_chat_screen">
              <div className="display-chat-screen-one">
                <div>
                  <h3>{props && props.logData && props.logData.issue_id}</h3>
                  <p className="bottom-text color-gray">Request Number</p>
                </div>
              </div>
              <div className="col-12 open_issues_view_tickets_chat_screen">
                <div className="chat-screen-max-height" id="style-4">
                  <ChatScreenIssuesTrack
                    comment={
                      props && props.logData && props.logData.issue_comments
                    }
                    auth={props && props.auth}
                  />
                </div>
              </div>
            </div>
            <div className="chat-submit-button">
              <div>
                <div className="input-group button-chat-box">
                  <input
                    type="text"
                    className="form-control input-box-height"
                    placeholder="Write your comment"
                    aria-label="Write your comment"
                    aria-describedby="button-addon2"
                    name="message"
                    value={props.message}
                    onChange={props.onChange}
                  />
                  <div className="input-group-append chat-button-box">
                    <div className="enChatFileUploadBtn">
                      <input type="file" />
                      <Image
                        fluid
                        alt="Back Icon"
                        title="Back Icon"
                        className="mr-2"
                        src={require("../../../../../assets/images/UserManagement/paper-clip.svg")}
                      />
                    </div>
                    <button
                      className="chat-button-box-button"
                      type="button"
                      id="button-addon2"
                      onClick={props.onClickAddComment}
                    >
                      <i
                        className="font-awesome-flag-size fa fa-paper-plane-o"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
